export const TESTIE_AFFILIATE_ID = 'aff::b3b5c422-0620-4868-83bc-d7bcfad6ac30';

export const isTestieAffiliate = (affiliateId?: string | null): boolean =>
  affiliateId === TESTIE_AFFILIATE_ID;

export const BRELLO_AFFILIATE_ID = 'aff::2e7cea28-f218-4209-acca-f77643a1d85f';
// Brello exists under a different id on dev, so keep both here or the
// Brello-only parts of the portal can never be exercised outside production.
export const BRELLO_AFFILIATE_ID_DEV =
  'aff::9fee3407-6f18-48b1-9170-392be4b708f6';

export const isBrelloAffiliate = (affiliateId?: string | null): boolean =>
  affiliateId === BRELLO_AFFILIATE_ID ||
  affiliateId === BRELLO_AFFILIATE_ID_DEV;
